import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'clever-paymentcancel',
    imports: [
        CommonModule
    ],
    templateUrl: './paymentcancel.component.html',
    styleUrl: './paymentcancel.component.scss'
})
export class PaymentcancelComponent implements OnInit {
    loading = signal<number>(0);
    protected isBrowser: boolean = false;
    constructor(
        protected route: ActivatedRoute,
        @Inject(PLATFORM_ID) protected platformId: any
        
    ) { }

    ngOnInit(): void {
        this.isBrowser = isPlatformBrowser(this.platformId);
        if(this.isBrowser) {
            this.checkParams();
        }
    }

    async checkParams() {
        const partnerid = this.route.snapshot.queryParams['partnerid'];
        if (this.route.snapshot.queryParams['params'] && this.route.snapshot.queryParams['params'].length > 0) {
            const ch = new BroadcastChannel('_check_payment_acvis_api_cancel_' + partnerid);
            this.loading.set(1);
            ch.postMessage({});
        } else {
            const ch = new BroadcastChannel('_check_payment_acvis_api_cancel_' + partnerid);
            ch.postMessage({});
            this.loading.set(2);
        }

        setTimeout(() => {
            window.close();
        }, 500);
    }
}
